<div class="row" *ngIf="controller">
  <div class="col-lg-12">
    <div class="grid">

      <p class="grid-header split-header">
        <span>{{controller.vendor?.name}}</span>
      </p>

      <div class="item-wrapper">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <th>IP Address</th>
              <th>Label</th>
              <th>Hostname</th>
              <th colspan="2">Links</th>
            </thead>
            <tbody>
              <tr *ngFor="let ip of controller.ips; let i = index">
                <td>{{ip.ip}}</td>
                <td>{{ip.label}}</td>
                <td>{{ip.hostname}}</td>
                <td colspan="2" class="row">
                  <div class="col-lg-6">
                    <div class="input-group">
                      <select [(ngModel)]="interfaceOptions.link" class="form-select">
                        <option *ngFor="let link of controller.vendor.links" value="https://{{ip.ip}}{{link.path}}">{{link.text}}</option>
                        <option value="{{controller.path}}">{{controller.vendor.default_path_text}}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-lg-6" *ngIf="interfaceOptions.link != null">
                    <div class="input-group">
                      <a href="{{interfaceOptions.link}}" class="btn btn-primary" target="_blank">Open Interface</a>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #interfaceModal let-modal>

  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{selectedIP.ip}}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body row">

    <div class="col-lg-4">
      <div class="input-group">
        <select [(ngModel)]="interfaceOptions.link" class="form-select">
          <option *ngFor="let link of controller.vendor.links" value="https://{{selectedIP.ip}}{{link.path}}">{{link.text}}</option>
          <option value="{{controller.path}}">{{controller.vendor.default_path_text}}</option>
        </select>
      </div>
    </div>

    <div class="col-lg-4" *ngIf="interfaceOptions.interfaceType != null">
      <div class="input-group">
        <a href="{{interfaceOptions.link}}" class="btn btn-primary" target="_blank">Open Interface</a>
      </div>
    </div>

  </div>
</ng-template>
